import { actionCopyIt } from "./actionCopy";
import { listCopyIt } from "./listCopy";

export const profileCopyIt = {
    title: "Profilo",
    description: "Gestisca il Suo profilo e le Sue impostazioni",
    contactDetails: "Recapiti",
    name: listCopyIt.name,
    titleLabel: "Titolo",
    selectPlaceholder: "Selezionare",
    requiredField: "Obbligatorio",
    firstNameRequired: "Il nome è obbligatorio",
    lastNameRequired: "Il cognome è obbligatorio",
    firstName: "Nome",
    lastName: "Cognome",
    noName: "Nessun nome",
    dateOfBirth: listCopyIt.dateOfBirth,
    dateOfBirthFormatDescription: "Usi il formato GG MM AAAA.",
    dobPlaceholderDay: "GG",
    dobPlaceholderMonth: "MM",
    dobPlaceholderYear: "AAAA",
    dobDayRequired: "Il giorno è obbligatorio",
    dobMonthRequired: "Il mese è obbligatorio",
    dobYearRequired: "L'anno è obbligatorio",
    dobMaxDaysInMonth: "Un mese ha al massimo 31 giorni",
    dobMonthsInYear: "Un anno ha solo 12 mesi",
    dobYearTooEarly: "Questo anno è troppo indietro nel tempo",
    dobYearInFuture: "È nel futuro.",
    noDateOfBirth: "Nessuna data di nascita",
    email: listCopyIt.email,
    noEmail: "Nessun indirizzo e-mail",
    updateEmail: "Modificare l'indirizzo e-mail",
    validEmailAddress: "Inserisca un indirizzo e-mail valido",
    accountSignInEmailRequired: "Inserisca l'indirizzo e-mail di accesso dell'account che sta modificando",
    newEmailDifferentFromSignIn:
        "Il nuovo indirizzo e-mail deve essere diverso dall'indirizzo e-mail di accesso che sta sostituendo",
    newEmailDifferentFromCurrent: "Il nuovo indirizzo e-mail deve essere diverso dal Suo indirizzo attuale",
    differentEmailAddress: "Inserisca un indirizzo e-mail diverso",
    noSignInEmailToChange: "Nessun indirizzo e-mail di accesso da modificare",
    emailUpdatedSuccessfully: "Indirizzo e-mail aggiornato correttamente",
    emailUpdateFailed: "Aggiornamento dell'indirizzo e-mail non riuscito. La preghiamo di riprovare.",
    emailSavedToProfile: "Indirizzo e-mail salvato nel Suo profilo",
    emailSaveToProfileFailed: "Impossibile salvare l'indirizzo e-mail nel Suo profilo. La preghiamo di riprovare.",
    loading: actionCopyIt.loading,
    profileEmailIntro: (email) => `L'indirizzo e-mail del profilo è ${email}.`,
    profileEmailIntroSuffix: "Inserisca il nuovo indirizzo qui sotto.",
    signInEmailDiffersHelp:
        "Se l'indirizzo e-mail di accesso differisce da quello del profilo (ad esempio dopo un problema di sincronizzazione), usi il campo facoltativo.",
    noProfileEmailReplaceDescription:
        "Nessun indirizzo e-mail su questo profilo. Inserisca l'indirizzo e-mail di accesso dell'account da sostituire, quindi il nuovo indirizzo.",
    signInEmailOnlyIfDifferent: "Indirizzo e-mail di accesso (solo se diverso da quello del profilo)",
    signInEmail: "Indirizzo e-mail di accesso",
    leaveBlankIfSameAsProfile: "Lasci vuoto se è identico a quello del profilo",
    newEmail: "Nuovo indirizzo e-mail",
    emailAddressToChangeTo: "Indirizzo e-mail da usare",
    accountSignInEmailIntro: (email) =>
        `L'indirizzo e-mail di accesso del Suo account è ${email}, ma non compare ancora nel Suo profilo. Può salvarlo nel Suo profilo ora.`,
    saveEmailToProfile: "Salvare l'indirizzo e-mail nel profilo",
    saveEmailFirstDescription:
        "Una volta salvato, potrà cambiare indirizzo da questa finestra. Per passare a un altro indirizzo con un link di conferma preliminare, usi",
    noProfileEmailAddDescription:
        "Il Suo profilo non ha ancora un indirizzo e-mail. Ne aggiunga uno qui sotto - ad esempio se si è registrata con il Suo numero di telefono.",
    profileEmailLink: "Profilo - E-mail",
    noEmailOnAccountPhoneSignup:
        "Nessun indirizzo e-mail su questo account al momento (ad esempio se si è registrata con il telefono)",
    currentEmail: "Indirizzo e-mail attuale",
    emailConfirmationSecurityDescription:
        "Le invieremo un link di conferma via e-mail. Per motivi di sicurezza, nulla cambia finché non apre questo link.",
    emailConfirmationSent:
        "Conferma inviata - controlli la nuova casella di posta per trovare il nostro link. Il Suo indirizzo e-mail di accesso non cambierà finché non avrà confermato.",
    emailChangeStartFailed: "Impossibile avviare il cambio di indirizzo e-mail. La preghiamo di riprovare.",
    sending: actionCopyIt.sending,
    sendConfirmationEmail: "Inviare l'e-mail di conferma",
    phone: "Telefono",
    noPhoneNumber: "Nessun numero di telefono",
    notifications: "Notifiche",
    notificationPreferences: "Preferenze di notifica",
    notificationPreferencesMissing: "Preferenze di notifica mancanti",
    notificationPreferencesNotSpecified: "Preferenze di notifica non specificate",
    notificationPreferencesDescription: "Scelga come desidera ricevere le notifiche",
    notificationsEnabled: "Attivate",
    notificationsDisabled: "Disattivate",
    notificationsDisabledWarningPatient:
        "Le consigliamo di attivare le notifiche via e-mail o SMS per ricevere i promemoria importanti sui Suoi inserimenti del diario e i messaggi.",
    notificationsDisabledWarningClinician:
        "Le consigliamo di attivare le notifiche via e-mail o SMS per ricevere i riepiloghi settimanali dell'andamento dei Suoi pazienti.",
    notificationPreferencesSaved: "Preferenze di notifica salvate",
    notificationPreferencesSaveFailed: "Salvataggio delle preferenze non riuscito",
    appearance: "Aspetto",
    darkMode: "Modalità scura",
    darkModeDescription: "Usi uno sfondo scuro in tutta l'app.",
    switchToDarkMode: "Passi alla modalità scura",
    switchToLightMode: "Passi alla modalità chiara",
    language: "Lingua",
    languageDescription: "Scelga la lingua dei menu, dei pulsanti e dei promemoria.",
    chooseLanguage: "Scegliere la lingua",
    otherActions: "Altre azioni",
    billingAndSubscription: "Fatturazione e abbonamento",
    hospitalDetails: "Informazioni ospedaliere",
    clinicianNumberLabel: "Numero di clinico",
    clinicianNumberDescription: "Si tratta del Suo numero GMC o HCPC",
    noClinicianNumber: "Nessun numero di clinico",
    myOrganisations: "Le mie organizzazioni",
    myTeam: "Équipe",
    teamPageDescription:
        "Tutte le persone delle Sue organizzazioni. Inviti i colleghi e scelga una persona di contatto predefinita.",
    secretaryDefaultHelpTitle: "Persona di contatto predefinita",
    secretaryDefaultHelp:
        "La Sua persona di contatto predefinita per un'organizzazione viene precompilata come contatto quando invita un paziente. Il primo segretario che aggiunge diventa la persona predefinita. Può modificarla nella tabella.",
    secretaryDefaultColumnHelp: "Usata come persona di contatto quando invita pazienti in questa organizzazione.",
    filterRole: "Ruolo",
    filterOrganisation: "Organizzazione",
    filterAddedBy: "Aggiunto da",
    filterAllRoles: "Tutti i ruoli",
    filterAllOrganisations: "Tutte le organizzazioni",
    filterAllAddedBy: "Tutti",
    filterInvitedByMe: "Invitati da me",
    filterNotInvitedByMe: "Non invitati da me",
    filterFavouritesOnly: "Solo preferiti",
    filters: actionCopyIt.filters,
    filterTeamAria: "Filtrare l'équipe",
    teamFilterTitle: "Filtri",
    teamFilterDescription: "Filtri questo elenco per ruolo, organizzazione e preferiti.",
    selectRoles: "Selezionare ruoli",
    selectOrganisations: "Selezionare organizzazioni",
    columnsButton: actionCopyIt.columns,
    columnName: listCopyIt.name,
    columnRole: listCopyIt.role,
    columnOrganisation: listCopyIt.organisation,
    columnAddedBy: "Aggiunto da",
    columnDefaultSecretary: "Persona di contatto predefinita",
    columnFavourite: "Preferito",
    invitedByYou: "L'ha invitata",
    addUser: "Aggiungere un utente",
    membersShown: (count) => `${count} ${count === 1 ? "membro" : "membri"}`,
    defaultForOrganisation: (organisationName) => `Predefinito per ${organisationName}`,
    setAsDefaultForOrganisation: (organisationName) => `Impostare come predefinito per ${organisationName}`,
    viewAll: "Vedere tutto",
    teamLabel: "Équipe",
    staffCount: (count) => `${count} membri del personale`,
    memberCount: (count) => `${count} ${count === 1 ? "membro" : "membri"}`,
    favouritesCount: (count) => `${count} ${count === 1 ? "preferito" : "preferiti"}`,
    moreTeamMembers: (count) => `+${count} altri membri dell'équipe`,
    noTeamMembersYet: "Nessun membro dell'équipe al momento",
    searchTeamPlaceholder: "Cercare...",
    searchTeamAria: "Cercare membri dell'équipe",
    closeSearch: "Chiudere la ricerca",
    openSearch: "Aprire la ricerca",
    allStaff: "Tutto il personale",
    invitedTab: "Invitati",
    favouritesTab: "Preferiti",
    noTeamMembersFound: "Nessun membro dell'équipe trovato.",
    noFavouritesYet: "Nessun preferito al momento.",
    noInvitesYet: "Non ha ancora invitato alcun utente.",
    inviteColleaguesToBuildTeam: "Inviti i colleghi per iniziare a costituire la Sua équipe",
    manageTeam: "Gestire l'équipe",
    secretaryOrganisationsLabel: "Organizzazioni del segretario",
    secretaryDefaultBadge: "Predefinito",
    setAsDefaultSecretary: "Impostare come predefinito",
    clearDefaultSecretary: "Rimuovere come predefinito",
    addAsMySecretary: "Aggiungere come mio segretario",
    removeAsMySecretary: "Rimuovere",
    addSecretaryForOrganisation: "Aggiungere un segretario",
    inviteNewSecretary: "Invitare un nuovo segretario",
    chooseExistingSecretary: "Scegliere nell'organizzazione",
    chooseExistingSecretaryTitle: "Scegliere un segretario",
    noOtherSecretariesInOrganisation: "Nessun altro segretario trovato in questa organizzazione.",
    inviteUser: "Invitare un utente",
    diaryUsageUsedLabel: "Utilizzo",
    diaryUsageUnlimited: "Diari illimitati",
    diaryUsageAtCapHint:
        "Ha raggiunto il Suo limite di diari per questo periodo. Passi a un piano superiore per invitare altri pazienti.",
    changePassword: "Modificare la password",
    logout: "Disconnettersi",
    help: "Aiuto",
    menu: "Menu",
    close: actionCopyIt.close,
    contactSupportPrompt: "Un dubbio o bisogno di aiuto?",
    contactSupport: "Contattare l'assistenza",
    incompleteTitle: "Profilo incompleto",
    incompleteMessage:
        "Per usare Patient Watch, completi prima il Suo profilo inserendo tutti i campi indicati come mancanti qui sotto.",
    profileCompletionLabel: (progress) => `Profilo completato al ${progress} %`,
    addNextMissingField: "Completare il Suo profilo",
    addMissingName: "Aggiungere il nome",
    addMissingDateOfBirth: "Aggiungere la data di nascita",
    addMissingEmail: "Aggiungere l'indirizzo e-mail",
    addMissingPhone: "Aggiungere il numero di telefono",
    addMissingOrganisation: "Aggiungere un'organizzazione",
    addMissingNotifications: "Aggiungere le preferenze di notifica",
    navProfileDescription: "Aggiorni le informazioni necessarie al corretto funzionamento di Patient Watch.",
    navDiaryLabel: "Diario",
    navDiaryDescription: "Crei diari che consentano ai pazienti di monitorare i propri sintomi.",
    goToDiary: "Andare al diario",
    addDoneSeeProgress: "Aggiunga ciò che è stato fatto e segua il Suo andamento",
    goToDiaries: "Andare ai diari",
    seeResults: "Vedere i risultati",
    seeDiaries: "Vedere i diari",
    onboarding: "Configurazione iniziale",
    onboardingNameTitle: "Qual è il Suo nome?",
    onboardingNameDescription: "È così che il Suo clinico La identificherà in Patient Watch.",
    onboardingDateOfBirthTitle: "Qual è la Sua data di nascita?",
    onboardingDateOfBirthDescription: "La usiamo per abbinare la Sua cartella sanitaria in modo sicuro.",
    onboardingEmailTitle: "Qual è il Suo indirizzo e-mail?",
    onboardingEmailDescription:
        "Lo useremo solo per il Suo account Patient Watch e per i messaggi legati alle Sue cure.",
    onboardingPhoneTitle: "Qual è il Suo numero di telefono?",
    onboardingPhoneDescription: "I promemoria via SMS La aiutano a compilare i moduli al momento giusto.",
    onboardingNotificationsTitle: "Come desidera essere sollecitata?",
    beginOnboarding: "Iniziare la configurazione",
    onboardingSignedOutDescription: "Faccia clic su Continuare per aggiungere le Sue informazioni.",
    continue: actionCopyIt.continue,
    next: actionCopyIt.next,
    save: actionCopyIt.save,
    cancel: actionCopyIt.cancel,
    skip: actionCopyIt.skip,
    skipConfirmTitle: "Desidera davvero saltare questo passaggio?",
    skipEmailDescription:
        "L'indirizzo e-mail serve a inviare notifiche importanti. Saltare questo passaggio può impedirLe di ricevere aggiornamenti tempestivi.",
    skipSmsDescription:
        "Il numero di telefono serve a inviare SMS di notifica importanti. Saltare questo passaggio può impedirLe di ricevere aggiornamenti tempestivi.",
    saving: actionCopyIt.saving,
    creating: "Creazione...",
    organisation: listCopyIt.organisation,
    organisationMissing: "Organizzazione mancante",
    addOrganisation: "Aggiungere un'organizzazione",
    joinOrganisation: "Unirsi a un'organizzazione",
    organisationMissingDescription: "Si unisca a un'organizzazione per creare diari.",
    addOrganisationToContinue: "Aggiunga un'organizzazione per continuare",
    informationMissing: "Informazioni mancanti",
    role: listCopyIt.role,
    openMenu: "Aprire il menu",
    showUsers: "Mostrare gli utenti",
    showQrCode: "Mostrare il codice QR",
    organisationCode: "Codice dell'organizzazione",
    organisationCodeDescriptionPrefix:
        "Per unirsi a un'organizzazione, usi il codice che Le è stato comunicato. Se non ne ha uno,",
    requestCode: "chieda un codice",
    delete: actionCopyIt.delete,
    deleting: actionCopyIt.deleting,
    rolePatient: "Paziente",
    roleClinician: "Clinico",
    roleSecretary: "Segretario",
    roleAdmin: "Amministratore",
    roleManager: "Responsabile",
    roleValidator: "Validatore",
    organisationDescription: "Si tratta del nome della Sua clinica, del Suo ambulatorio o del Suo ospedale.",
    profileOrganisationDescription:
        "L'aggiunta di un'organizzazione consentirà la condivisione dei dati tra Lei e questa organizzazione.",
    yourOrganisation: "La Sua organizzazione",
    professional: "Professionale",
    medicalSpecialty: "Specialità medica",
    selectSpecialty: "Selezionare una specialità",
    specialtyDescription: "Creeremo modelli specifici per la Sua specialità",
    professionalRegistrationNumber: "Numero di iscrizione professionale (facoltativo)",
    professionalRegistrationPlaceholder: "GMC, HCPC o altro numero di iscrizione",
    professionalRegistrationDescription: "Il Suo numero GMC, HCPC o di iscrizione all'ordine professionale",
    welcomeTitle: "Benvenuta su Patient Watch.",
    welcomePatientDescription: "Aiuti a migliorare le cure e la ricerca monitorando il Suo percorso di recupero.",
    welcomeClinicianDescription:
        "Offra ai Suoi pazienti cure personalizzate, risparmi consulti e raccolga informazioni preziose sui Suoi trattamenti.",
    welcomeSecretaryDescription:
        "Gestisca le cartelle dei pazienti e coordini le cure in modo efficace all'interno della Sua équipe.",
    welcomeManagerDescription: "Monitori il modo in cui i dati vengono raccolti nella Sua organizzazione.",
    settingUpAccount: "Configurazione del Suo account...",
    gettingAccountReady: "Stiamo preparando tutto per Lei",
    continueToProfileSetup: "Continuare verso la configurazione del profilo",
    processingNewUser: "Elaborazione del nuovo utente",
    onboardingComplete: "Configurazione iniziale completata",
    authenticationError: "Errore di autenticazione",
    setupMoment: "Un attimo, stiamo configurando tutto...",
    settingUpDiary: "Configurazione del Suo diario...",
    almostThere: "Quasi terminato.",
    patientSetupCompleteDescription:
        "Grazie per aver completato la configurazione. Aggiunga i Suoi inserimenti del diario man mano, e potrà poi vedere i Suoi punteggi sul grafico di andamento.",
    setupCompleteDescription:
        "Ora può usare Patient Watch per condividere il Suo andamento con la Sua équipe sanitaria e ricevere le cure migliori possibili.",
    supportMessage: "Invii un messaggio a support@patient-watch.com",
    retry: actionCopyIt.retry,
    edit: actionCopyIt.edit,
    current: "Attuale",
    change: "Modificare",
    deleteAccount: "Eliminare l'account",
    deleteAccountConfirmTitle: "È assolutamente sicura?",
    deleteAccountConfirmDescription:
        'Questa azione è irreversibile. Per confermare che desidera eliminare il Suo account, inserisca "delete my account" qui sotto.',
    deleteAccountPageDescription: "Elimini definitivamente il Suo account e tutti i dati associati",
    deleteAccountReason: "Motivo dell'eliminazione dell'account",
    deleteAccountSubmit: "Eliminare l'account",
    submitting: actionCopyIt.submitting,
    deleteAccountConfirmationLabel: "Conferma",
    deleteAccountPlaceholder: 'Inserisca "delete my account"',
    deletingAccount: "Eliminazione...",
    warningNotificationsDisabled: "Attenzione: notifiche disattivate",
    editPreferences: "Modificare le preferenze",
    remindersDescription: "I promemoria sono essenziali affinché Patient Watch migliori la Sua salute.",
    receiveEmailReminders: "Ricevere promemoria via e-mail.",
    receiveSmsReminders: "Ricevere promemoria via SMS.",
    pushNotificationSettingsError:
        "Per attivare le notifiche push, deve attivare le notifiche nelle impostazioni della Sua app.",
    actionRequired: (count) => `Azione richiesta (${count})`,
    actionRequiredForms: (count) => `Azione richiesta (${count} modul${count === 1 ? "o" : "i"})`,
    diaryCardDescription:
        "I diari sono i Suoi monitoraggi di salute personali e aiutano a migliorare le cure e la ricerca.",
    formDue: (count) => `Ha ${count} modul${count === 1 ? "o" : "i"} da compilare.`,
    diariesNeedAttention: (count) =>
        `Ha ${count} ${count === 1 ? "diario" : "diari"} i cui moduli richiedono la Sua attenzione.`,
    welcomeModalTitle: (name: string) => `Benvenuta, ${name}.`,
    welcomeDescription:
        "Il Suo account è completamente configurato e i modelli della Sua specialità sono pronti all'uso.",
    welcomeTestPatientTitle: "Provi con un paziente di prova",
    welcomeTestPatientDescription:
        "Per vedere come i Suoi pazienti vivranno Patient Watch, inviti un utente di prova con un altro indirizzo e-mail.",
    welcomeAddFirstPatient: "Aggiungere il mio primo paziente",
    welcomeDoctorFallback: "Dottore",
    closeBanner: "Chiudere il banner",
    home: "Pagina iniziale",
    currentPlan: "Piano attuale",
    currentPlanDescription: "Il Suo abbonamento e la Sua quota di diari",
    noActiveSubscription: "Non ha un abbonamento attivo",
    billingStatus: "Stato",
    nextBillingDate: "Prossima data di fatturazione",
    accessUntil: "Accesso fino al",
    planDetails: "Dettagli del piano",
    trialPlanDetails: "5 nuovi diari per periodo di fatturazione",
    enterprisePlanDetails: "Diari illimitati",
    choosePlanToStart: "Scelga un piano per iniziare con Patient Watch",
    upgradeYourPlan: "Passare a un piano superiore",
    changeYourPlan: "Cambiare piano",
    availablePlans: "Piani disponibili",
    upgradePlanDescription: "Passi dal piano gratuito a Starter o Pro per una quota di diari più elevata",
    changePlanDescription: "Confronti i piani e modifichi il Suo abbonamento",
    choosePlanDescription: "Scelga il piano più adatto alle Sue esigenze",
    preferStartFree: "Preferisce iniziare gratuitamente?",
    createFreeAccount: "Creare un account gratuito",
    needMore: "Serve di più? Scopra il nostro",
    enterprisePlan: "piano Enterprise",
    cancelSubscription: "Disdire l'abbonamento",
    managePaymentMethod: "Gestire il metodo di pagamento",
    undoCancellationHint:
        "Desidera mantenere il Suo piano? Usi « Gestire il metodo di pagamento » per riaprire Stripe e annullare la disdetta.",
    paymentRequired: "Pagamento richiesto",
    paymentOverdue:
        "Il Suo pagamento è in ritardo. Aggiorni il metodo di pagamento per continuare a usare Patient Watch.",
    subscriptionCanceling: "Disdetta dell'abbonamento in corso",
    subscriptionCancelingOn: (date) =>
        `Il Suo abbonamento sarà disdetto il ${date}. Manterrà l'accesso fino a tale data.`,
    subscriptionCancelingPeriod:
        "Il Suo abbonamento sarà disdetto alla fine del periodo di fatturazione. Manterrà l'accesso fino a tale data.",
    subscriptionCancelled: "Abbonamento disdetto",
    subscriptionCancelledDescription:
        "Il Suo abbonamento a pagamento è terminato. Scelga un piano qui sotto per riprendere la fatturazione.",
    unableToCancel: "Impossibile disdire",
    unableToChangePlan: "Impossibile cambiare piano",
    unableToOpenBillingPortal: "Impossibile aprire il portale di fatturazione",
    unableToStartCheckout: "Impossibile avviare il pagamento",
    failedToLoadBilling:
        "Caricamento delle informazioni di fatturazione non riuscito. La preghiamo di riprovare più tardi.",
    billingStatusCanceling: "DISDETTA IN CORSO",
    billingStatusUnknown: "SCONOSCIUTO",
    pleaseTryAgain: "La preghiamo di riprovare.",
    planStarter: "Starter",
    planPro: "Pro",
    perMonth: "/mese",
    currentPlanBadge: "Attuale",
    popularBadge: "Popolare",
    starterDiaries: "20 nuovi diari/mese",
    proDiaries: "50 nuovi diari/mese",
    emailSmsReminders: "Promemoria via e-mail e SMS",
    emailSupport: "Assistenza via e-mail",
    prioritySupport: "Assistenza prioritaria",
    currentPlanButton: "Piano attuale",
    subscribeToStarter: "Sottoscrivere Starter",
    subscribeToPro: "Sottoscrivere Pro",
    downgradeToStarter: "Passare a Starter",
    upgradeToPro: "Passare a Pro",
    includedInEnterprise: "Incluso in Enterprise",
};
